export default {
  pwmatgpu: {
    banner: 'LS3DF',
    title: 'LS3DF',
    describe: `
    下面所列安装包均采用GPU卡UUID认证LICENSE的方式，龙讯根据用户提供的UUID产生证书文件pwmat.lic，该证书文件需要放在服务器/opt/pwmat/文件夹下,PWmat默认回去该文件夹下去读取LICENSE文件。如用户没有服务器root权限，无法将证书文件放在/opt/pwmat/目录下，可以在运行PWmat时，在PWmat后跟-lic-path参数指定LICENSE文件所在的文件夹：PWmat -lic-path 'path-to-pwmat.lic'。除超算中心以及大规模集群,绝大部分用户均下载该版本进行软件安装或者更新。用户下载PWmat安装包前，请首先确认自己服务器上MPI以及CUDA版本，根据对应关系下载安装包。如有任何操作不明之处请及时联系龙讯工作人员或发送邮件到support@pwmat.com！！！
    `,
    tableR0C1: 'CUDA 版本',
    tableR0C2: 'MPI 版本',
    tableR0C3: 'PWmat 版本',
    tableR0C4: '安装包',
    tableR0C5: '更新时间',
    note: '注',
    note1: 'PWmat安装说明',
    note2: '获取 GPU UUID 方法',
    note3: '历史版本下载',
    title2: '启动 server.py 服务认证 LICENSE 版本',
    describe2: `
    下面所列安装包均采用在集群登录或者管理节点启动 server.py 服务认证 LICENSE 的方式，超算中心或大规模集群用户均下载该版本进行软件安装或者更新。用户下载 PWmat 安装包前，请首先确认自己服务器上 MPI 以及 CUDA 版本，根据对应关系下载安装包。特别注意，运行该版本PWmat时，需要在 PWmat 指定部署 server.py 服务的节点的 IP 以及通讯端口，IP 和通讯端口设置方法请参考 server.py 服务安装说明！！！`,
    note22: 'server.py 服务安装说明',
  },
  pwmatdcu: {
    title: 'DCU 版本',
    describe: `
    DCU版本PWmat安装包均采用在集群登录或者管理节点启动server.py服务认证LICENSE的方式。
    用户下载PWmat安装包前，请首先确认自己服务器上DTK、MKL库、MPI及gcc版本，根据对应关系下载安装包。
    `,
    tableR0C1: 'DTK 版本',
    tableR0C2: 'MPI 及 gcc 版本',
  },
  pwmatcpu: {
    title: 'CPU 版本',
    describe: `
    CPU版本PWmat安装包均采用在集群登录或者管理节点启动server.py服务认证LICENSE的方式。
    用户下载PWmat安装包前，请首先确认自己服务器上MKL库及MPI版本，根据对应关系下载安装包。
    `,
    tableR0C1: 'CPU 架构',
    tableR0C2: 'MKL 及 MPI 版本',
  },
  pwmatwin: {
    title: 'Windows 版本',
    describe: `
    对于Windows版本，PWmat目前仅支持自洽计算（JOB=SCF）、非自洽计算（JOB=NONSCF）、态密度计算（JOB=DOS）、
    原子位置优化计算（JOB=RELAX）和分子动力学计算（JOB=MD），不支持加入VDW以及LDA+U等修正。
    `,
    tableR0C1: '版本',
    tableR0C2: '发布日期',
    tableR0C3: 'winpwmat 图形界面版下载',
    tableR0C4: '功能介绍',
    tableR1C3: '下载安装包',
  }
}